/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * macweb API
 * OpenAPI spec version: 0.4.45
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AutoreadRow,
  ConsumptionRow,
  EventLogEntry,
  EventType,
  GroupProfileResponse,
  LastDataSections,
  MatrixResponse,
  NetworkDataResponse,
  NetworkTelemetryDataResponse,
  PhaseDiagramResponse,
  PowerQualityResponse,
  ProfileRow,
  ReportsAutoreadParams,
  ReportsConsumptionParams,
  ReportsEventLogParams,
  ReportsGroupProfileParams,
  ReportsLastDataParams,
  ReportsMatrixParams,
  ReportsNetworkParams,
  ReportsNetworkTelemetryParams,
  ReportsPhaseDiagramParams,
  ReportsPowerQualityParams,
  ReportsProfileParams,
  ReportsTouParams,
  TouRow
} from '.././model';

import { customInstance } from '../../orvalMutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * @summary Last data report
 */
export const reportsLastData = (
    params: ReportsLastDataParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<LastDataSections>(
      {url: `/api/reports/last-data`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getReportsLastDataQueryKey = (params?: ReportsLastDataParams,) => {
    return [
    `/api/reports/last-data`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getReportsLastDataQueryOptions = <TData = Awaited<ReturnType<typeof reportsLastData>>, TError = unknown>(params: ReportsLastDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reportsLastData>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getReportsLastDataQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof reportsLastData>>> = ({ signal }) => reportsLastData(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof reportsLastData>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ReportsLastDataQueryResult = NonNullable<Awaited<ReturnType<typeof reportsLastData>>>
export type ReportsLastDataQueryError = unknown


export function useReportsLastData<TData = Awaited<ReturnType<typeof reportsLastData>>, TError = unknown>(
 params: ReportsLastDataParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof reportsLastData>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof reportsLastData>>,
          TError,
          Awaited<ReturnType<typeof reportsLastData>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReportsLastData<TData = Awaited<ReturnType<typeof reportsLastData>>, TError = unknown>(
 params: ReportsLastDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reportsLastData>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof reportsLastData>>,
          TError,
          Awaited<ReturnType<typeof reportsLastData>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReportsLastData<TData = Awaited<ReturnType<typeof reportsLastData>>, TError = unknown>(
 params: ReportsLastDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reportsLastData>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Last data report
 */

export function useReportsLastData<TData = Awaited<ReturnType<typeof reportsLastData>>, TError = unknown>(
 params: ReportsLastDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reportsLastData>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getReportsLastDataQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Event type reference
 */
export const reportsEventTypes = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<EventType[]>(
      {url: `/api/reports/events/types`, method: 'GET', signal
    },
      options);
    }
  



export const getReportsEventTypesQueryKey = () => {
    return [
    `/api/reports/events/types`
    ] as const;
    }

    
export const getReportsEventTypesQueryOptions = <TData = Awaited<ReturnType<typeof reportsEventTypes>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reportsEventTypes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getReportsEventTypesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof reportsEventTypes>>> = ({ signal }) => reportsEventTypes(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof reportsEventTypes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ReportsEventTypesQueryResult = NonNullable<Awaited<ReturnType<typeof reportsEventTypes>>>
export type ReportsEventTypesQueryError = unknown


export function useReportsEventTypes<TData = Awaited<ReturnType<typeof reportsEventTypes>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof reportsEventTypes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof reportsEventTypes>>,
          TError,
          Awaited<ReturnType<typeof reportsEventTypes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReportsEventTypes<TData = Awaited<ReturnType<typeof reportsEventTypes>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reportsEventTypes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof reportsEventTypes>>,
          TError,
          Awaited<ReturnType<typeof reportsEventTypes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReportsEventTypes<TData = Awaited<ReturnType<typeof reportsEventTypes>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reportsEventTypes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Event type reference
 */

export function useReportsEventTypes<TData = Awaited<ReturnType<typeof reportsEventTypes>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reportsEventTypes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getReportsEventTypesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Event log
 */
export const reportsEventLog = (
    params: ReportsEventLogParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<EventLogEntry[]>(
      {url: `/api/reports/events/logs`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getReportsEventLogQueryKey = (params?: ReportsEventLogParams,) => {
    return [
    `/api/reports/events/logs`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getReportsEventLogQueryOptions = <TData = Awaited<ReturnType<typeof reportsEventLog>>, TError = unknown>(params: ReportsEventLogParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reportsEventLog>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getReportsEventLogQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof reportsEventLog>>> = ({ signal }) => reportsEventLog(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof reportsEventLog>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ReportsEventLogQueryResult = NonNullable<Awaited<ReturnType<typeof reportsEventLog>>>
export type ReportsEventLogQueryError = unknown


export function useReportsEventLog<TData = Awaited<ReturnType<typeof reportsEventLog>>, TError = unknown>(
 params: ReportsEventLogParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof reportsEventLog>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof reportsEventLog>>,
          TError,
          Awaited<ReturnType<typeof reportsEventLog>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReportsEventLog<TData = Awaited<ReturnType<typeof reportsEventLog>>, TError = unknown>(
 params: ReportsEventLogParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reportsEventLog>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof reportsEventLog>>,
          TError,
          Awaited<ReturnType<typeof reportsEventLog>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReportsEventLog<TData = Awaited<ReturnType<typeof reportsEventLog>>, TError = unknown>(
 params: ReportsEventLogParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reportsEventLog>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Event log
 */

export function useReportsEventLog<TData = Awaited<ReturnType<typeof reportsEventLog>>, TError = unknown>(
 params: ReportsEventLogParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reportsEventLog>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getReportsEventLogQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Consumption report
 */
export const reportsConsumption = (
    params: ReportsConsumptionParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ConsumptionRow[]>(
      {url: `/api/reports/consumption`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getReportsConsumptionQueryKey = (params?: ReportsConsumptionParams,) => {
    return [
    `/api/reports/consumption`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getReportsConsumptionQueryOptions = <TData = Awaited<ReturnType<typeof reportsConsumption>>, TError = unknown>(params: ReportsConsumptionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reportsConsumption>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getReportsConsumptionQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof reportsConsumption>>> = ({ signal }) => reportsConsumption(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof reportsConsumption>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ReportsConsumptionQueryResult = NonNullable<Awaited<ReturnType<typeof reportsConsumption>>>
export type ReportsConsumptionQueryError = unknown


export function useReportsConsumption<TData = Awaited<ReturnType<typeof reportsConsumption>>, TError = unknown>(
 params: ReportsConsumptionParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof reportsConsumption>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof reportsConsumption>>,
          TError,
          Awaited<ReturnType<typeof reportsConsumption>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReportsConsumption<TData = Awaited<ReturnType<typeof reportsConsumption>>, TError = unknown>(
 params: ReportsConsumptionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reportsConsumption>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof reportsConsumption>>,
          TError,
          Awaited<ReturnType<typeof reportsConsumption>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReportsConsumption<TData = Awaited<ReturnType<typeof reportsConsumption>>, TError = unknown>(
 params: ReportsConsumptionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reportsConsumption>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Consumption report
 */

export function useReportsConsumption<TData = Awaited<ReturnType<typeof reportsConsumption>>, TError = unknown>(
 params: ReportsConsumptionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reportsConsumption>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getReportsConsumptionQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Automatic readings report
 */
export const reportsAutoread = (
    params: ReportsAutoreadParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<AutoreadRow[]>(
      {url: `/api/reports/autoread`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getReportsAutoreadQueryKey = (params?: ReportsAutoreadParams,) => {
    return [
    `/api/reports/autoread`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getReportsAutoreadQueryOptions = <TData = Awaited<ReturnType<typeof reportsAutoread>>, TError = unknown>(params: ReportsAutoreadParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reportsAutoread>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getReportsAutoreadQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof reportsAutoread>>> = ({ signal }) => reportsAutoread(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof reportsAutoread>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ReportsAutoreadQueryResult = NonNullable<Awaited<ReturnType<typeof reportsAutoread>>>
export type ReportsAutoreadQueryError = unknown


export function useReportsAutoread<TData = Awaited<ReturnType<typeof reportsAutoread>>, TError = unknown>(
 params: ReportsAutoreadParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof reportsAutoread>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof reportsAutoread>>,
          TError,
          Awaited<ReturnType<typeof reportsAutoread>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReportsAutoread<TData = Awaited<ReturnType<typeof reportsAutoread>>, TError = unknown>(
 params: ReportsAutoreadParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reportsAutoread>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof reportsAutoread>>,
          TError,
          Awaited<ReturnType<typeof reportsAutoread>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReportsAutoread<TData = Awaited<ReturnType<typeof reportsAutoread>>, TError = unknown>(
 params: ReportsAutoreadParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reportsAutoread>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Automatic readings report
 */

export function useReportsAutoread<TData = Awaited<ReturnType<typeof reportsAutoread>>, TError = unknown>(
 params: ReportsAutoreadParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reportsAutoread>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getReportsAutoreadQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Time-of-use readings
 */
export const reportsTou = (
    params: ReportsTouParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<TouRow[]>(
      {url: `/api/reports/tou`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getReportsTouQueryKey = (params?: ReportsTouParams,) => {
    return [
    `/api/reports/tou`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getReportsTouQueryOptions = <TData = Awaited<ReturnType<typeof reportsTou>>, TError = unknown>(params: ReportsTouParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reportsTou>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getReportsTouQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof reportsTou>>> = ({ signal }) => reportsTou(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof reportsTou>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ReportsTouQueryResult = NonNullable<Awaited<ReturnType<typeof reportsTou>>>
export type ReportsTouQueryError = unknown


export function useReportsTou<TData = Awaited<ReturnType<typeof reportsTou>>, TError = unknown>(
 params: ReportsTouParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof reportsTou>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof reportsTou>>,
          TError,
          Awaited<ReturnType<typeof reportsTou>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReportsTou<TData = Awaited<ReturnType<typeof reportsTou>>, TError = unknown>(
 params: ReportsTouParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reportsTou>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof reportsTou>>,
          TError,
          Awaited<ReturnType<typeof reportsTou>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReportsTou<TData = Awaited<ReturnType<typeof reportsTou>>, TError = unknown>(
 params: ReportsTouParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reportsTou>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Time-of-use readings
 */

export function useReportsTou<TData = Awaited<ReturnType<typeof reportsTou>>, TError = unknown>(
 params: ReportsTouParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reportsTou>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getReportsTouQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Load profile data
 */
export const reportsProfile = (
    params: ReportsProfileParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ProfileRow[]>(
      {url: `/api/reports/profile`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getReportsProfileQueryKey = (params?: ReportsProfileParams,) => {
    return [
    `/api/reports/profile`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getReportsProfileQueryOptions = <TData = Awaited<ReturnType<typeof reportsProfile>>, TError = unknown>(params: ReportsProfileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reportsProfile>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getReportsProfileQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof reportsProfile>>> = ({ signal }) => reportsProfile(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof reportsProfile>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ReportsProfileQueryResult = NonNullable<Awaited<ReturnType<typeof reportsProfile>>>
export type ReportsProfileQueryError = unknown


export function useReportsProfile<TData = Awaited<ReturnType<typeof reportsProfile>>, TError = unknown>(
 params: ReportsProfileParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof reportsProfile>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof reportsProfile>>,
          TError,
          Awaited<ReturnType<typeof reportsProfile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReportsProfile<TData = Awaited<ReturnType<typeof reportsProfile>>, TError = unknown>(
 params: ReportsProfileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reportsProfile>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof reportsProfile>>,
          TError,
          Awaited<ReturnType<typeof reportsProfile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReportsProfile<TData = Awaited<ReturnType<typeof reportsProfile>>, TError = unknown>(
 params: ReportsProfileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reportsProfile>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Load profile data
 */

export function useReportsProfile<TData = Awaited<ReturnType<typeof reportsProfile>>, TError = unknown>(
 params: ReportsProfileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reportsProfile>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getReportsProfileQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Group profile (aggregated)
 */
export const reportsGroupProfile = (
    groupID: string,
    params: ReportsGroupProfileParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GroupProfileResponse>(
      {url: `/api/reports/groups/${groupID}/profile`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getReportsGroupProfileQueryKey = (groupID?: string,
    params?: ReportsGroupProfileParams,) => {
    return [
    `/api/reports/groups/${groupID}/profile`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getReportsGroupProfileQueryOptions = <TData = Awaited<ReturnType<typeof reportsGroupProfile>>, TError = unknown>(groupID: string,
    params: ReportsGroupProfileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reportsGroupProfile>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getReportsGroupProfileQueryKey(groupID,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof reportsGroupProfile>>> = ({ signal }) => reportsGroupProfile(groupID,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(groupID), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof reportsGroupProfile>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ReportsGroupProfileQueryResult = NonNullable<Awaited<ReturnType<typeof reportsGroupProfile>>>
export type ReportsGroupProfileQueryError = unknown


export function useReportsGroupProfile<TData = Awaited<ReturnType<typeof reportsGroupProfile>>, TError = unknown>(
 groupID: string,
    params: ReportsGroupProfileParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof reportsGroupProfile>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof reportsGroupProfile>>,
          TError,
          Awaited<ReturnType<typeof reportsGroupProfile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReportsGroupProfile<TData = Awaited<ReturnType<typeof reportsGroupProfile>>, TError = unknown>(
 groupID: string,
    params: ReportsGroupProfileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reportsGroupProfile>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof reportsGroupProfile>>,
          TError,
          Awaited<ReturnType<typeof reportsGroupProfile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReportsGroupProfile<TData = Awaited<ReturnType<typeof reportsGroupProfile>>, TError = unknown>(
 groupID: string,
    params: ReportsGroupProfileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reportsGroupProfile>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Group profile (aggregated)
 */

export function useReportsGroupProfile<TData = Awaited<ReturnType<typeof reportsGroupProfile>>, TError = unknown>(
 groupID: string,
    params: ReportsGroupProfileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reportsGroupProfile>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getReportsGroupProfileQueryOptions(groupID,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Network parameters report
 */
export const reportsNetwork = (
    params: ReportsNetworkParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<NetworkDataResponse>(
      {url: `/api/reports/network`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getReportsNetworkQueryKey = (params?: ReportsNetworkParams,) => {
    return [
    `/api/reports/network`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getReportsNetworkQueryOptions = <TData = Awaited<ReturnType<typeof reportsNetwork>>, TError = unknown>(params: ReportsNetworkParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reportsNetwork>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getReportsNetworkQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof reportsNetwork>>> = ({ signal }) => reportsNetwork(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof reportsNetwork>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ReportsNetworkQueryResult = NonNullable<Awaited<ReturnType<typeof reportsNetwork>>>
export type ReportsNetworkQueryError = unknown


export function useReportsNetwork<TData = Awaited<ReturnType<typeof reportsNetwork>>, TError = unknown>(
 params: ReportsNetworkParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof reportsNetwork>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof reportsNetwork>>,
          TError,
          Awaited<ReturnType<typeof reportsNetwork>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReportsNetwork<TData = Awaited<ReturnType<typeof reportsNetwork>>, TError = unknown>(
 params: ReportsNetworkParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reportsNetwork>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof reportsNetwork>>,
          TError,
          Awaited<ReturnType<typeof reportsNetwork>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReportsNetwork<TData = Awaited<ReturnType<typeof reportsNetwork>>, TError = unknown>(
 params: ReportsNetworkParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reportsNetwork>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Network parameters report
 */

export function useReportsNetwork<TData = Awaited<ReturnType<typeof reportsNetwork>>, TError = unknown>(
 params: ReportsNetworkParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reportsNetwork>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getReportsNetworkQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Network telemetry report
 */
export const reportsNetworkTelemetry = (
    params?: ReportsNetworkTelemetryParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<NetworkTelemetryDataResponse>(
      {url: `/api/reports/networktelemetry`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getReportsNetworkTelemetryQueryKey = (params?: ReportsNetworkTelemetryParams,) => {
    return [
    `/api/reports/networktelemetry`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getReportsNetworkTelemetryQueryOptions = <TData = Awaited<ReturnType<typeof reportsNetworkTelemetry>>, TError = unknown>(params?: ReportsNetworkTelemetryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reportsNetworkTelemetry>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getReportsNetworkTelemetryQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof reportsNetworkTelemetry>>> = ({ signal }) => reportsNetworkTelemetry(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof reportsNetworkTelemetry>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ReportsNetworkTelemetryQueryResult = NonNullable<Awaited<ReturnType<typeof reportsNetworkTelemetry>>>
export type ReportsNetworkTelemetryQueryError = unknown


export function useReportsNetworkTelemetry<TData = Awaited<ReturnType<typeof reportsNetworkTelemetry>>, TError = unknown>(
 params: undefined |  ReportsNetworkTelemetryParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof reportsNetworkTelemetry>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof reportsNetworkTelemetry>>,
          TError,
          Awaited<ReturnType<typeof reportsNetworkTelemetry>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReportsNetworkTelemetry<TData = Awaited<ReturnType<typeof reportsNetworkTelemetry>>, TError = unknown>(
 params?: ReportsNetworkTelemetryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reportsNetworkTelemetry>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof reportsNetworkTelemetry>>,
          TError,
          Awaited<ReturnType<typeof reportsNetworkTelemetry>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReportsNetworkTelemetry<TData = Awaited<ReturnType<typeof reportsNetworkTelemetry>>, TError = unknown>(
 params?: ReportsNetworkTelemetryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reportsNetworkTelemetry>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Network telemetry report
 */

export function useReportsNetworkTelemetry<TData = Awaited<ReturnType<typeof reportsNetworkTelemetry>>, TError = unknown>(
 params?: ReportsNetworkTelemetryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reportsNetworkTelemetry>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getReportsNetworkTelemetryQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Power quality report
 */
export const reportsPowerQuality = (
    params: ReportsPowerQualityParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PowerQualityResponse>(
      {url: `/api/reports/power-quality`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getReportsPowerQualityQueryKey = (params?: ReportsPowerQualityParams,) => {
    return [
    `/api/reports/power-quality`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getReportsPowerQualityQueryOptions = <TData = Awaited<ReturnType<typeof reportsPowerQuality>>, TError = unknown>(params: ReportsPowerQualityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reportsPowerQuality>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getReportsPowerQualityQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof reportsPowerQuality>>> = ({ signal }) => reportsPowerQuality(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof reportsPowerQuality>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ReportsPowerQualityQueryResult = NonNullable<Awaited<ReturnType<typeof reportsPowerQuality>>>
export type ReportsPowerQualityQueryError = unknown


export function useReportsPowerQuality<TData = Awaited<ReturnType<typeof reportsPowerQuality>>, TError = unknown>(
 params: ReportsPowerQualityParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof reportsPowerQuality>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof reportsPowerQuality>>,
          TError,
          Awaited<ReturnType<typeof reportsPowerQuality>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReportsPowerQuality<TData = Awaited<ReturnType<typeof reportsPowerQuality>>, TError = unknown>(
 params: ReportsPowerQualityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reportsPowerQuality>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof reportsPowerQuality>>,
          TError,
          Awaited<ReturnType<typeof reportsPowerQuality>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReportsPowerQuality<TData = Awaited<ReturnType<typeof reportsPowerQuality>>, TError = unknown>(
 params: ReportsPowerQualityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reportsPowerQuality>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Power quality report
 */

export function useReportsPowerQuality<TData = Awaited<ReturnType<typeof reportsPowerQuality>>, TError = unknown>(
 params: ReportsPowerQualityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reportsPowerQuality>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getReportsPowerQualityQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Matrix report
 */
export const reportsMatrix = (
    params: ReportsMatrixParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<MatrixResponse>(
      {url: `/api/reports/matrix`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getReportsMatrixQueryKey = (params?: ReportsMatrixParams,) => {
    return [
    `/api/reports/matrix`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getReportsMatrixQueryOptions = <TData = Awaited<ReturnType<typeof reportsMatrix>>, TError = unknown>(params: ReportsMatrixParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reportsMatrix>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getReportsMatrixQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof reportsMatrix>>> = ({ signal }) => reportsMatrix(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof reportsMatrix>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ReportsMatrixQueryResult = NonNullable<Awaited<ReturnType<typeof reportsMatrix>>>
export type ReportsMatrixQueryError = unknown


export function useReportsMatrix<TData = Awaited<ReturnType<typeof reportsMatrix>>, TError = unknown>(
 params: ReportsMatrixParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof reportsMatrix>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof reportsMatrix>>,
          TError,
          Awaited<ReturnType<typeof reportsMatrix>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReportsMatrix<TData = Awaited<ReturnType<typeof reportsMatrix>>, TError = unknown>(
 params: ReportsMatrixParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reportsMatrix>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof reportsMatrix>>,
          TError,
          Awaited<ReturnType<typeof reportsMatrix>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReportsMatrix<TData = Awaited<ReturnType<typeof reportsMatrix>>, TError = unknown>(
 params: ReportsMatrixParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reportsMatrix>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Matrix report
 */

export function useReportsMatrix<TData = Awaited<ReturnType<typeof reportsMatrix>>, TError = unknown>(
 params: ReportsMatrixParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reportsMatrix>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getReportsMatrixQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Phase diagram report
 */
export const reportsPhaseDiagram = (
    params: ReportsPhaseDiagramParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PhaseDiagramResponse>(
      {url: `/api/reports/phase-diagram`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getReportsPhaseDiagramQueryKey = (params?: ReportsPhaseDiagramParams,) => {
    return [
    `/api/reports/phase-diagram`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getReportsPhaseDiagramQueryOptions = <TData = Awaited<ReturnType<typeof reportsPhaseDiagram>>, TError = unknown>(params: ReportsPhaseDiagramParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reportsPhaseDiagram>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getReportsPhaseDiagramQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof reportsPhaseDiagram>>> = ({ signal }) => reportsPhaseDiagram(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof reportsPhaseDiagram>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ReportsPhaseDiagramQueryResult = NonNullable<Awaited<ReturnType<typeof reportsPhaseDiagram>>>
export type ReportsPhaseDiagramQueryError = unknown


export function useReportsPhaseDiagram<TData = Awaited<ReturnType<typeof reportsPhaseDiagram>>, TError = unknown>(
 params: ReportsPhaseDiagramParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof reportsPhaseDiagram>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof reportsPhaseDiagram>>,
          TError,
          Awaited<ReturnType<typeof reportsPhaseDiagram>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReportsPhaseDiagram<TData = Awaited<ReturnType<typeof reportsPhaseDiagram>>, TError = unknown>(
 params: ReportsPhaseDiagramParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reportsPhaseDiagram>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof reportsPhaseDiagram>>,
          TError,
          Awaited<ReturnType<typeof reportsPhaseDiagram>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReportsPhaseDiagram<TData = Awaited<ReturnType<typeof reportsPhaseDiagram>>, TError = unknown>(
 params: ReportsPhaseDiagramParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reportsPhaseDiagram>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Phase diagram report
 */

export function useReportsPhaseDiagram<TData = Awaited<ReturnType<typeof reportsPhaseDiagram>>, TError = unknown>(
 params: ReportsPhaseDiagramParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reportsPhaseDiagram>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getReportsPhaseDiagramQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




